import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from '../../UI/Grid';
import { wrap } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var ListHeader = function ListHeader(_ref) {
  var title = _ref.title,
      actions = _ref.actions;
  return ___EmotionJSX("div", {
    css: wrap
  }, ___EmotionJSX(Row, {
    horizontalGap: 16,
    align: "center"
  }, ___EmotionJSX(Col, {
    sm: 12,
    md: true
  }, ___EmotionJSX("h4", null, title)), ___EmotionJSX(Col, {
    sm: 12,
    md: "auto"
  }, actions)));
};

ListHeader.propTypes = {
  title: PropTypes.string,
  actions: PropTypes.any
};
export default ListHeader;